import { degreeToRadian } from './angles.js';
export const fromDegrees = (radiusX, radiusY, rotationDeg = 0, startAngleDeg = 0, endAngleDeg = 360) => ({
    radiusX, radiusY,
    rotation: degreeToRadian(rotationDeg),
    startAngle: degreeToRadian(startAngleDeg),
    endAngle: degreeToRadian(endAngleDeg)
});
